import { signOut, signInWithEmailAndPassword } from "firebase/auth";
import { useEffect, useRef } from "react";
import { auth } from "./firebase";
import { addAuthInfo } from "../Redux/authentication/actions";

export async function loginWithEmailAndPassword(data) {
  return await signInWithEmailAndPassword(auth, data.email, data.password);
}

export function useAuthSubscriber(onAuthStateChange) {
  const isAuth = useRef(null);

  useEffect(() => {
    auth.onIdTokenChanged(async (user) => {
      if (user) {
        const accessToken = await user.getIdToken();
        const idTokenResult = await user.getIdTokenResult();
        const { claims } = idTokenResult;
        addAuthInfo({
          accessToken,
          uid: user.uid,
          email: user.email,
          zones: claims?.locations?.zones || null
        });
        if (isAuth.current !== true) {
          isAuth.current = true;
          onAuthStateChange({ isAuth: isAuth.current, claims });
        }
      } else if (!user && isAuth.current !== false) {
        await logout();
        isAuth.current = false;
        onAuthStateChange({ isAuth: isAuth.current, claims: null });
      }
    });
    // eslint-disable-next-line
  }, []);

  return isAuth.current;
}

export const logout = async () => {
  await signOut(auth);
};
